import http from './http'

/**
 * Envia o contacto para o backend.
 * Espera que o backend aceite JSON com:
 *  name, email, subject, message, 'g-recaptcha-response', website_hp, started_at
 */
export async function sendContact(payload) {
  // Usa variável específica para o endpoint completo OU junta /api/contact ao baseURL
  const explicitUrl = process.env.VUE_APP_SEND_EMAIL // ex.: http://localhost:8000/api/contact
  const url = explicitUrl || '/api/contact'

  try {
    const res = await http.post(url, payload)
    if (res?.data?.success !== true) {
      const msg = res?.data?.message || 'Falha no envio'
      console.log(msg)
    }
    return res.data
  } catch (err) {
    if (err.response) {
      const msg = err.response.data?.message || 'Erro no servidor'
      throw new Error(`Erro ${err.response.status}: ${msg}`)
    }
    if (err.request) {
      throw new Error('Erro de rede. Verifica se o backend está ativo e CORS permitido.')
    }
    throw err
  }
}
